<template>
    <div>
        <!--临时创建 单页面================== -->
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                主要产品
            </div>
            <div style="text-align: center; color:#999" class="font_size_16">
                面向互联网应用，服务商、运营商、广电媒体、金融保险提供互联网新媒体相关领域的系列产品
            </div>
        </div>
        <!-- 盒子 -->
        <!-- 主要产品 -->
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[0].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[0].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[1].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[1].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[2].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[2].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12"  :md="6">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[3].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[3].title}}</div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[4].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[4].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[5].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[5].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[6].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[6].title}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12"  :md="6">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[7].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[7].title}}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 解决方案 -->
        <div class="data-guide-wrap product_mobile">
            <div style="text-align: center; font-size:30px; margin-bottom:10px;">
                核心技术优势
            </div>
            <!-- <div style="text-align: center; font-size:20px; margin-bottom:10px;">
                为互联网+提供多角度、全流程、专业化的解决方案
            </div> -->
            <div class="container-solution border_parent">
            <el-row :gutter="10">
                    <el-col :span="8">
                        <div class="border">
                            <div class="border_img_parent">
                                <img :src="solutions[0].img" class="solu_img_border"/>
                            </div>
                            <div class="border_title">{{solutions[0].title}}</div>
                            <div class="border-sub-title">{{solutions[0].content}}</div>

                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="border">
                            <div class="border_img_parent">
                                <img :src="solutions[1].img" class="solu_img_border"/>
                            </div>
                            <div class="border_title">{{solutions[1].title}}</div>
                            <div class="border-sub-title">{{solutions[1].content}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="border">
                            <div class="border_img_parent">
                                <img :src="solutions[2].img" class="solu_img_border"/>
                            </div>
                            <div class="border_title">{{solutions[2].title}}</div>
                            <div class="border-sub-title">{{solutions[2].content}}</div>
                        </div>
                    </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="solutions[3].img" class="solu_img_border"/>
                        </div>
                        <div class="border_title">{{solutions[3].title}}</div>
                        <div class="border-sub-title">{{solutions[3].content}}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="solutions[4].img" class="solu_img_border"/>
                        </div>
                        <div class="border_title">{{solutions[4].title}}</div>
                        <div class="border-sub-title">{{solutions[4].content}}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="solutions[5].img" class="solu_img_border"/>
                        </div>
                        <div class="border_title">{{solutions[5].title}}</div>
                        <div class="border-sub-title">{{solutions[5].content}}</div>
                    </div>
                </el-col>
            </el-row>
            </div>

        </div>
        <!--  =======================================================================专业服务-->
        <div class="cooperation head-label">
            <div style="text-align: center;" class="font_size_30">
                专业服务
            </div>
            <div style="text-align: center; margin:20px" class="font_size_20">
                提供以客户为中心的配套服务
            </div>
        </div>
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :span="12">
                    <div class="server_border">
                        <img :src="servers[0].img" class="server_img_border"/>
                        <div class="right-wrap">
                            <div>{{servers[0].title}}</div>
                            <span>{{servers[0].content}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="server_border">
                        <img :src="servers[1].img" class="server_img_border"/>
                        <div class="right-wrap">
                            <div >{{servers[1].title}}</div>
                            <span >{{servers[1].content}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <div class="server_border">
                        <img :src="servers[2].img" class="server_img_border"/>
                        <div class="right-wrap">
                            <div >{{servers[2].title}}</div>
                            <span >{{servers[2].content}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="server_border">
                        <img :src="servers[3].img" class="server_img_border"/>
                        <div class="right-wrap">
                            <div>{{servers[3].title}}</div>
                            <span>{{servers[3].content}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <div class="server_border">
                        <img :src="servers[4].img" class="server_img_border"/>
                        <div class="right-wrap">
                            <div >{{servers[4].title}}</div>
                            <span>{{servers[4].content}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 关于我们-->
        <!-- <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p>
            </div>
        </div> -->

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                images: [
                    {
                        // img: require('../../static/product/product_item_1.png'),
                        img: require('../../src/assets/product/product_item_1.png'),
                        title: "小程序定制开发",
                        content: ["店铺模板切换", "店铺商品上架"]
                    },
                    {
                        img: require('../../src/assets/product/product_item_2.png'),
                        title: "高端网站定制开发",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }, {
                        img: require('../../src/assets/product/product_item_3.png'),
                        title: "代驾系统",
                        content: ["营销活动通知", "用户粘连度提升"]
                    },
                    {
                        img: require('../../src/assets/product/product_item_4.png'),
                        title: "移动APP解决方案",
                        content: ["打造店铺自主品牌", "品牌多样化管理"]
                    },
                    {
                        img: require('../../src/assets/product/product_item_5.png'),
                        title: "内容传播矩阵",
                        content: ["店铺模板切换", "店铺商品上架"]
                    },
                    {
                        img: require('../../src/assets/product/product_item_6.png'),
                        title: "智慧超商系统",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }, {
                        img: require('../../src/assets/product/product_item_7.png'),
                        title: "电子工单系统",
                        content: ["营销活动通知", "用户粘连度提升"]
                    },
                    {
                        img: require('../../src/assets/product/product_item_8.png'),
                        title: "客户端中间件",
                        content: ["打造店铺自主品牌", "品牌多样化管理"]
                    }
                ],
                solutions: [
                    {
                        img: require('../../src/assets/solu/solu_1.png'),
                        title: "周期管理",
                        content: '多维度活动生命周期控制'
                    },
                    {
                        img: require('../../src/assets/solu/solu_2.png'),
                        title: "用户管理",
                        content: '支持面向多种用户，进行分众管理'
                    }, {
                        img: require('../../src/assets/solu/solu_3.png'),
                        title: "大容量",
                        content: '支持过亿级别的用户参与'
                    },
                    {
                        img: require('../../src/assets/solu/solu_4.png'),
                        title: "高并发",
                        content: '支持高并发情况下, 活动不中断'
                    },
                    {
                        img: require('../../src/assets/solu/solu_5.png'),
                        title: "安全保障",
                        content: '严格控制活动, 奖品安全'
                    },
                    {
                        img: require('../../src/assets/solu/solu_6.png'),
                        title: "在线管理",
                        content: '在线运营, 实时管控'
                    },
                ],
                servers: [
                    {
                        img: require('../../src/assets/server/server_1.png'),
                        title: "推广",
                        content: ["针对移动互联网的推广服务通过优质的手机APP推广渠道资源有效执行，快速提升APP的知名度和下载量，帮助客户建立手机APP的品牌规模。"]
                    },
                    {
                        img: require('../../src/assets/server/server_2.png'),
                        title: "运营",
                        content: ["承担营销策划的运营服务网达软件能够为客户提供数百人的驻场运营团队，提供完善的员工培训及管理机制，帮助客户完成运营人力资源受限问题。"]
                    }, {
                        img: require('../../src/assets/server/server_3.png'),
                        title: "咨询",
                        content: ["基于专家团队的咨询服务网达软件的专家团队是具备丰富的实战经验、问题分析与抽象能力、深入浅出的沟通能力。 向客户提供该领域的可行性方案。"]
                    },
                    {
                        img: require('../../src/assets/server/server_4.png'),
                        title: "定制",
                        content: ["提供敏捷开发的定制服务在软件定制服务领域，基于个性化需求的设计，我们量身定制为企业带来准确、便捷、实用、稳定的软件。"]
                    },
                    {
                        img: require('../../src/assets/server/server_5.png'),
                        title: "运维",
                        content: ["面向集成实施的运维服务网达软件利用各种IT运维工具，通过运维服务的有效管理提升客户IT基础设施的服务效率"]
                    },
                ],
                
           
                company: [
                    "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                    "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                    "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                    "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    // img: require("../../static/slider/a1.jpg")
                    img: require("../assets/banner/banner_img_1.png")
                },
                {
                    img: require("../assets/banner/banner_img_2.png")
                },
                {
                    img: require("../assets/banner/banner_img_3.jpg")
                },
                // {
                //     img: require('../../static/slider/a3.jpg')
                // },
                // {
                //     img: require('../../static/slider/a4.jpg')
                // }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },

        },
    }
</script>

<style scoped lang="scss">
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 550px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 20px 0px;
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        // margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        // display: flex;
        // justify-content: center;
        // width: 90%;
        // margin: 20px auto;
        // align-items: center;
        // height: auto
        width: 90%;
        height: 640px;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
        display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        flex-direction: column;
        padding-top: 50px;
        color: white;
        // background: red;
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
        height: 30px;
        // background: orange;
    }
    .border-sub-title {
        text-align: center;
        // background: red;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        // margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .solu_img_border {
        margin-top: 15px;
        width: 120px;
        height: 120px
    }

    .server_img_border {
        margin-top: 15px;
        width: 120px;
        height: 120px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }
    
    .server_border{
        // border: 1px solid red;
        display: flex;
        align-items: center;
        text-align: left;
        height: 180px;
        div{
            text-align: left;
            font-size: 23px;
            margin-bottom: 10px;
        }
        span{
            font-size: 16px;
        }
    }
    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        height: 640px;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
        display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        flex-direction: column;
        background: url(../assets/solutionBackground.png);
        padding-top: 50px;
        color: white;
        .container-solution{
            width: 80%;
            // border: 1px solid red;
            margin: 20px auto;
            ::v-deep .border{
                border: none !important;
                box-shadow: none;
            }
            // display: flex;
        }
    }
    .item {
        width: 48%;
        display: inline-block;
        /* border: 1px solid red; */
        margin-bottom: 10px;
        padding: 15px;
        display: flex;
    }
    .right-wrap{
        margin-left: 20px;
        height: 90px;
        /* line-height: 90px; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* background: orange; */
        /* display: flex; */
        /* align-items: center; */
    }
    .item-title{
        margin-bottom: 10px;
    }
    .item-sub-title{
        color: #999;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            // margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>